import { useEffect, useState } from 'react';
import { ordersApi } from '@verlo/shared/services/api';

// The venue's VAT rate, as the till prices orders with it (Oct 2026, Chris's review H3): the
// cart's "Includes VAT" before an order exists. Read once per page load; until it answers,
// null, and the cart shows no VAT figure rather than a guessed one.
let asked = null;

export default function useVatRate() {
  const [rate, setRate] = useState(null);
  useEffect(() => {
    let live = true;
    asked = asked || ordersApi.pricing().then((r) => Number(r.data?.vat_rate) || 0).catch(() => { asked = null; return null; });
    asked.then((v) => { if (live) setRate(v); });
    return () => { live = false; };
  }, []);
  return rate;
}

/** The VAT inside a VAT-inclusive amount, at `rate`; null when the rate isn't known yet. */
export const vatInside = (amount, rate) => (rate == null ? null : Math.round((amount - amount / (1 + rate)) * 100) / 100);
